import { render, staticRenderFns } from "./EventsTab.vue?vue&type=template&id=0797d62a&"
import script from "./EventsTab.vue?vue&type=script&lang=js&"
export * from "./EventsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/akryum/Projects/vue-devtools/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0797d62a')) {
      api.createRecord('0797d62a', component.options)
    } else {
      api.reload('0797d62a', component.options)
    }
    module.hot.accept("./EventsTab.vue?vue&type=template&id=0797d62a&", function () {
      api.rerender('0797d62a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@vue-devtools/app-frontend/src/views/events/EventsTab.vue"
export default component.exports